import type {UsersApiResponse, User} from '../types';
import type {SessionState} from './session-reducer';

export const REDUCER_KEY = 'session';

export type SessionModuleState = {
    session: SessionState;
};

export const ActionTypes = {
    SESSION_FETCH_SESSION_REQUEST: 'SESSION_FETCH_SESSION_REQUEST',
    SESSION_FETCH_SESSION_SUCCESS: 'SESSION_FETCH_SESSION_SUCCESS',
    SESSION_FETCH_SESSION_FAILURE: 'SESSION_FETCH_SESSION_FAILURE',
    SESSION_HACKY_DOM_USER_ADDED: 'SESSION_HACKY_DOM_USER_ADDED',
    SESSION_UPDATE_AGENT_STATUS: 'SESSION_UPDATE_AGENT_STATUS',
    SESSION_UPDATE_MAIN_SIDEBAR_COLLAPSED: 'SESSION_UPDATE_MAIN_SIDEBAR_COLLAPSED',
    SESSION_UPDATE_EXPLORE_ATTENTION_BADGE: 'SESSION_UPDATE_EXPLORE_ATTENTION_BADGE',
} as const;

export type FetchSessionRequestAction = {
    readonly type: 'SESSION_FETCH_SESSION_REQUEST';
    payload: {
        baseUrl: string;
        options?: RequestInit;
    };
};
export type FetchSessionSuccessAction = {
    readonly type: 'SESSION_FETCH_SESSION_SUCCESS';
    payload: UsersApiResponse;
};
export type FetchSessionFailureAction = {
    readonly type: 'SESSION_FETCH_SESSION_FAILURE';
    payload: any | null | undefined;
    error: true;
};
export type AddHackyDomUserAction = {
    readonly type: 'SESSION_HACKY_DOM_USER_ADDED';
    payload: User | null | undefined;
};
export type SessionUpdateAgentStatusAction = {
    type: typeof ActionTypes.SESSION_UPDATE_AGENT_STATUS;
    payload: {
        agentStatus: 'ONLINE' | 'NOT_ACCEPTING_CHATS';
    };
};
export type SessionUpdateMainSidebarCollapsedAction = {
    type: typeof ActionTypes.SESSION_UPDATE_MAIN_SIDEBAR_COLLAPSED;
    payload: {
        isMainSidebarCollapsed: boolean;
    };
};
export type SessionUpdateExploreAttentionBadgeAction = {
    type: typeof ActionTypes.SESSION_UPDATE_EXPLORE_ATTENTION_BADGE;
    payload: {
        shouldShowExploreAttentionBadge: boolean;
    };
};

export type SessionAction =
    | FetchSessionRequestAction
    | FetchSessionSuccessAction
    | FetchSessionFailureAction
    | AddHackyDomUserAction
    | SessionUpdateAgentStatusAction
    | SessionUpdateMainSidebarCollapsedAction
    | SessionUpdateExploreAttentionBadgeAction;
